export default "__VITE_ASSET__D5pNejW0__"